import { render, staticRenderFns } from "./tags_loader.vue.js?vue&type=template&id=d32099ec!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tags_loader.vue?vue&type=template&id=d32099ec"
import script from "./tags_loader.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tags_loader.vue?vue&type=script&lang=js"
export * from "./tags_loader.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tags_loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports